import { useNavigate } from 'react-router-dom'
import { ChevronLeft, ShieldCheck, Ban, Lock, Users, Eye, Flag } from 'lucide-react'

const TIPS = [
  {
    icon: Ban,
    title: 'Never send money',
    body: 'No genuine match will ask for money, UPI transfers, gift cards, or your bank/OTP details — for a medical emergency, travel, or any reason. Requests like these are the #1 sign of a scam. Stop and report immediately.',
  },
  {
    icon: Lock,
    title: 'Guard your personal information',
    body: 'Don’t share your Aadhaar, PAN, bank details, home address, or workplace early on. Keep conversations on Ahirwal Matrimony until you genuinely trust the person and their family.',
  },
  {
    icon: Users,
    title: 'Meet safely, involve family',
    body: 'When you meet, choose a public place and tell a family member where you’re going. Involving parents and elders early is both safer and part of how our community builds trust.',
  },
  {
    icon: Eye,
    title: 'Watch for warning signs',
    body: 'Be cautious of anyone who rushes the relationship, refuses phone or video calls, gives inconsistent details, or quickly pushes to move the chat to WhatsApp or another app.',
  },
  {
    icon: ShieldCheck,
    title: 'Prefer verified profiles',
    body: 'Look for the ID Verified badge. It means the member submitted a government ID that our team reviewed.',
  },
  {
    icon: Flag,
    title: 'Report and block',
    body: 'If something feels wrong, use Report or Block on the person’s profile or chat. Our team reviews every report within 24 hours, and repeated reports lead to automatic suspension.',
  },
]

export default function SafetyCenterPage() {
  const navigate = useNavigate()
  return (
    <div className="max-w-2xl mx-auto px-5 py-6">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1 text-ink-400 hover:text-maroon-700 mb-4"
      >
        <ChevronLeft size={20} /> Back
      </button>

      <div className="flex flex-col items-center text-center mb-8">
        <div className="w-16 h-16 rounded-full border border-gold-500/60 flex items-center justify-center mb-4">
          <ShieldCheck size={30} className="text-maroon-700" />
        </div>
        <p className="kicker">Safety Center</p>
        <h1 className="font-display font-semibold text-3xl text-ink-900 mt-2">Staying safe on your journey</h1>
        <p className="text-ink-400 text-sm mt-3 max-w-md">
          Finding a life partner should feel joyful and secure. A few simple habits keep you and your
          family protected from fraud and bad actors.
        </p>
      </div>

      <div className="space-y-3">
        {TIPS.map(({ icon: Icon, title, body }) => (
          <div key={title} className="bg-ivory-25 rounded-2xl border border-ivory-200 p-5 flex gap-4">
            <div className="w-10 h-10 rounded-full bg-maroon-700/5 border border-gold-500/30 flex items-center justify-center flex-shrink-0">
              <Icon size={18} className="text-maroon-700" />
            </div>
            <div>
              <h2 className="font-display font-semibold text-ink-900 text-lg leading-tight">{title}</h2>
              <p className="text-ink-600 text-sm mt-1.5 leading-relaxed">{body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 bg-maroon-700/5 border border-gold-500/30 rounded-2xl p-5 text-center">
        <p className="text-ink-900 text-sm font-semibold">See something suspicious?</p>
        <p className="text-ink-400 text-sm mt-1">
          Report or block the member from their profile or chat. We’re here to help — every report is
          reviewed within 24 hours.
        </p>
      </div>
    </div>
  )
}
